import React from 'react';

import { DifferentAspectsOfLifeImage } from 'assets/LoansAndCreditResources';
import { HalfCurtain, TallManFatBoyTemplate, BannerHeader } from 'components/Templates';
import { colorScale } from 'themes';

import { LoansAndCreditResourcesContent } from './LoansAndCreditResourcesContent';

export const LoansAndCreditResourcesPage = () => {
  return (
    <>
      <HalfCurtain curtainColor={colorScale('primary', 10)} />
      <TallManFatBoyTemplate
        header={
          <BannerHeader
            title="Loans and credit resources"
            image={<DifferentAspectsOfLifeImage />}
          />
        }
        content={<LoansAndCreditResourcesContent />}
      />
    </>
  );
};
